<section class="page">
  <header class="page-header">
    <h2>Modifier une chimie</h2>
  </header>

  <div *ngIf="success" class="success-toast">{{ success }}</div>
  <div *ngIf="error" class="error-toast">{{ error }}</div>

  <form (ngSubmit)="update()" #chimieForm="ngForm">
    <label for="select-chimie">Choisir la chimie à modifier</label>
    <select id="select-chimie" [(ngModel)]="id" name="id" (change)="onSelectChange()">
      <option [ngValue]="null">-- Sélectionner --</option>
      <option *ngFor="let c of chimies" [ngValue]="c.id">{{ c.nom }}</option>
    </select>
    <div *ngIf="id">
      <label for="nom">Nom de la chimie</label>
      <input id="nom" name="nom" [(ngModel)]="nom" required />
      <button type="submit" [disabled]="loading">Modifier</button>
    </div>
  </form>
</section>
